import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";

const OrdersPage = lazy(() => import("./pages/OrdersPage").then(module => ({ default: module.OrdersPage })));

export const orderRoutes: RouteObject[] = [
  {
    path: "orders",
    element: <RouteSuspense><OrdersPage /></RouteSuspense>,
  },
];
